// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1hftG","info":"UpdateTermsInfo_info__1K3Wx"};